// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 664 ? "reactPlayerPreview" : chunkId) + "." + {"664":"fb57598e","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};